import { Status } from '../../database';

export const AllSettings = (status = Status.PUBLISHED) => `
    query Settings {
      settings ${status === Status.DRAFT ? '(stage: DRAFT)' : ''} {
        siteName
        siteLogo
        defaultLocale
      }
    }
`;
